module.exports = __webpack_public_path__ + "static/media/facebook.c725b8e7.svg";